export default {
  init() {
  
 

    const SiteNavbar = document.querySelector('.siteHeader')
    function stickyNavbar() {
        
        
        
      window.scrollY > 0 ? SiteNavbar.classList.add('stickyNavbar') : SiteNavbar.classList.remove('stickyNavbar')
        
      }
  
  
  
      window.addEventListener('scroll', () => {
        stickyNavbar()
      })
  

      $('.hamburger').click(function() {
        $(this).toggleClass('is-active');
        document.querySelector('.mobileNav').classList.toggle('is-active')
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js